import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CognitoService } from 'src/app/modules/core/services/cognito.service';
import { SideBarLeftComponent } from '../sidebar-left/sidebar-left.component';
@Component({
    selector: 'app-siderbar-top',
    templateUrl: './siderbar-top.component.html',
    styleUrls: ['./siderbar-top.component.scss'],
})
export class SideBarTopComponent implements OnInit {
    @ViewChild('menuProfiler') menu: ElementRef;
    @ViewChild('toggleButtonProfiler') toggleButton: ElementRef;
    isMenuOpen = false;
    user: any;
    constructor(
        private renderer: Renderer2,
        private router: Router,
        private cognitoService: CognitoService,
        public dialog: MatDialog,
    ) {
        this.renderer.listen('window', 'click', e => {
            if (
                ['profiler-top-bar', 'profiler-top-bar-span', 'profiler-icon-top-bar', 'profiler-icon'].indexOf(
                    e.target.id,
                ) == -1
            ) {
                this.isMenuOpen = false;
            }
        });
    }

    ngOnInit() {
    }

    setActiveProfiler() {
        this.isMenuOpen = !this.isMenuOpen;
    }

    ngOnDestroy(): void {}

    showMenuMoblie() {
        this.dialog.open(SideBarLeftComponent, {
            width: '50%',
            height: '100vh',
            autoFocus: false,
            position: {
                left: '0px',
            },
            panelClass: ['position-relative', 'mobile-sidebar'],
            // data: {
            //     name: this.name,
            //     image: this.image,
            //     admin: this.admin,
            //     orgAdmin: this.orgAdmin,
            //     simulationAdmin: this.simulationAdmin,
            //     user: this.user,
            // },
        });
    }

    onLogOut() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        this.cognitoService.signOut();
        this.router.navigate(['/login']);
    }
}
